(function ($) {
  $(document).on( 'ready', function(){
    $('.prevnext__title').wrap('<span class="prevnext__title-wrap"></span>'); // wrapp title in span, so it can dissapear beautifully
  });
})(jQuery);

